module.exports = __webpack_public_path__ + "img/WhatsApp.0e599da1.png";